import * as React from "react";
import { TextFieldProps, TextField, IconButton, SxProps, Theme, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import ClearIcon from "@mui/icons-material/Clear";

export interface CclInfoTableEditDateTimePickerProps {
    value: string;
    onChange?: (newDate: Date | null, required: boolean) => void;
    required?: boolean;
    readonly: boolean;
    sx?: SxProps<Theme>;
    minDate?: Date;
    maxDate?: Date;
}

function parseDate(value: string): Date | null {
    if (!value) return null;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
}

const CclInfoTableEditDatePicker: React.FC<CclInfoTableEditDateTimePickerProps> = (props) => {
    const [datetime, setdatetime] = React.useState<Date | null>(parseDate(props.value));

    React.useEffect(() => {
        setdatetime(parseDate(props.value));
    }, [props.value]);

    const onChange = (newdate: Date | null) => {
        setdatetime(newdate);
        if (props.onChange != null) props.onChange(newdate, props?.required ?? false);
    };

    return (
        <>
            {props.readonly ? (

                <>
                    <Typography sx={{ ...props?.sx, fontSize: 14, width: 1, overflow: "hidden" }}>
                        {datetime ? datetime.toLocaleDateString() : props.value}
                    </Typography>
                </>
            ):(
                <>
                    <DatePicker
                        disabled={props.readonly}
                        label=""
                        value={datetime}
                        onChange={onChange}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => {
                            params.fullWidth = true;
                            params.variant = "standard";
                            params.inputProps = { style: { fontSize: 14 } };
                            params.value = datetime?.toLocaleDateString() || "";
                            return <TextField {...params} />;
                        }}
                    ></DatePicker>
                    {!props.readonly && !props.required && (
                        <IconButton
                            // style={{ padding: 0 }}
                            edge="end"
                            size="small"
                            disabled={!datetime}
                            onClick={() => onChange(null)}
                        >
                            <ClearIcon />
                        </IconButton>
                    )}
                </>
            )}
        </>
    );
};

export default CclInfoTableEditDatePicker;
